import { Dropdown } from "react-bootstrap";
import styles from "./vehiclecard.module.css";
import { AlertCircle, AlertTriangle, CheckCircle, Clock, Edit, MoreVertical, Send, Trash2, X, XCircle } from "react-feather";
import { useHistory } from "react-router-dom";
import { Dialog, Popover } from "@mui/material";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

// ── Derive passType + passStatus the same way List.jsx does ──────────────────
const resolvePassData = (item) => {
  let passType = "day";
  let passStatus = "active";
  try {
    const stored = localStorage.getItem(`vehicle_pass_${item.id}`);
    if (stored) {
      const passData = JSON.parse(stored);
      passType = passData.pass_type || "day";
      passStatus = passData.pass_status || "active";
    } else {
      const name = `${item.guest_fname || ""} ${item.guest_lname || ""}`.toLowerCase();
      if (name.includes("imani johnson")) {
        passType = "day";
        passStatus = "active";
      } else if (name.includes("diana osei")) {
        passType = "monthly";
        passStatus = "expired";
      } else if (name.includes("mark liu")) {
        passType = "day";
        passStatus = "awaiting";
      } else {
        const idNum = parseInt(item.id) || 0;
        if (idNum % 3 === 0) {
          passType = "day";
          passStatus = "active";
        } else if (idNum % 3 === 1) {
          passType = "monthly";
          passStatus = "expired";
        } else {
          passType = "day";
          passStatus = "awaiting";
        }
      }
    }
  } catch (e) { /* ignored */ }
  return { passType, passStatus };
};

// ── Derive all display values from passType + passStatus ─────────────────────
const buildPassDisplay = (passType, passStatus) => {
  const passPrice = passType === "monthly" ? 30.00 : 5.00;
  const passName = passType === "monthly" ? "Monthly pass" : "Day pass";
  const passAmount = `$${passPrice.toFixed(2)}`;

  let passLabel = "";
  let passSubLabel = "";
  let passColor = "";
  let passBackgroundColor = "";
  let passStatusText = "";
  let passStatusIcon = null;
  let passValidFrom = null;
  let passWasValid = null;
  let passExpires = null;
  let passRemaining = null;
  let alertType = "";   // "warning" | "error" | ""
  let alertText = "";

  if (passStatus === "active") {
    passLabel = `Active · ${passType === "monthly" ? "Monthly" : "Day pass"}`;
    passSubLabel = "Expires Jun 17, 2026";
    passColor = "#43a847";
    passBackgroundColor = "#d4fbe5";
    passStatusText = "Paid & Active";
    passStatusIcon = <CheckCircle size={14} style={{ color: '#43a847' }} />;
    passValidFrom = "Jun 16, 2026";
    passExpires = "Jun 17, 2026";
    passRemaining = "14h 32m";
    alertType = "warning";
    alertText = "Pass expires in less than 24 hours. Send renewal link to guest.";
  } else if (passStatus === "expired") {
    passLabel = `Expired · ${passType === "monthly" ? "Monthly" : "Day pass"}`;
    passSubLabel = "Expired Jun 15, 2026";
    passColor = "#e23725";
    passBackgroundColor = "#ffe8e8";
    passStatusText = "Expired";
    passStatusIcon = <X size={14} style={{ color: '#e23725' }} />;
    passWasValid = "May 16 – Jun 15, 2026";
    alertType = "error";
    alertText = `Access restricted. ${passType === "monthly" ? "Monthly" : "Day"} pass expired Jun 15, 2026.`;
  } else {
    // awaiting
    passLabel = "Awaiting payment";
    passSubLabel = "Link sent Jun 16";
    passColor = "#E99A37";
    passBackgroundColor = "#fff3e8";
    passStatusText = "Awaiting payment";
    passStatusIcon = <Clock size={14} style={{ color: '#E99A37' }} />;
    alertType = "warning";
    alertText = "Payment link sent Jun 16. Guest has not paid yet.";
  }

  return {
    passPrice, passName, passAmount,
    passLabel, passSubLabel,
    passColor, passBackgroundColor,
    passStatusText, passStatusIcon,
    passValidFrom, passWasValid, passExpires, passRemaining,
    alertType, alertText,
  };
};

const VehicleCard = ({ item, setDeleteVehicleModalOpen, setSelectedId, setEditData, setEditModalOpen, showBadge, setTenantModalOpen, setTenantDetails }) => {
  const redirect = useHistory();
  const { user, isAuthenticated } = useAuth0();
  const [anchorEl, setAnchorEl] = useState(null);
  const [carImage, setCarImage] = useState("");
  const [openPop, setOpenPop] = useState(false);
  const [parkingPanelOpen, setParkingPanelOpen] = useState(false);

  const isGuest = parseInt(item?.is_guest) === 1;

  // Resolve dynamic pass data (mirrors List.jsx logic)
  const { passType, passStatus } = isGuest ? resolvePassData(item) : {};
  const pass = isGuest ? buildPassDisplay(passType, passStatus) : null;

  const handleClose = () => {
    setOpenPop(false);
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCarImage("");
  };
  const open = Boolean(anchorEl);

  const goToTenantetails = (row) => {
    if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-contactinfo:read") > -1 && user["https://propertydek.com/permissions"].indexOf("tenant-journey:read") > -1) {
      redirect.push("/people/tenants/details/" + row.tenant_id);
    } else {
      setTenantModalOpen(true);
      setTenantDetails(row?.tenant_details);
    }
  }

  return (<>
    {/*  <div className={`${styles.ProspectCard}`} style={{ cursor: "pointer" }} onClick={(e) => {
      if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1) {
        setEditModalOpen(true);
        setEditData(item);
      } else {
        return false;
      }
    }}>
      <div className={`${styles.ProspectCardUnder}`}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          <div className={`${styles.LeaseIMGSec} ${styles.Big}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
            {item?.image_path ? (<span onMouseEnter={(e) => { setCarImage(item?.image_path); e.preventDefault(); e.stopPropagation(); handlePopoverOpen(e); }} onMouseLeave={handlePopoverClose} style={{ width: "100%", height: "100%" }}>
              <img src={item?.image_path} alt="" className={`${styles.CarUploadImage}`} />
            </span>) : (<img src="/static/img/car.svg" alt="" className={`${styles.Icon}`} />)}
          </div>
          <div className={`${styles.LeaseIMGSec} ${styles.Small}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
            {item?.image_path ? (<span onClick={(e) => { setCarImage(item?.image_path); e.preventDefault(); e.stopPropagation(); handleOpen(); }} style={{ width: "100%", height: "100%" }}>
              <img src={item?.image_path} alt="" className={`${styles.CarUploadImage}`} />
            </span>) : (<img src="/static/img/car.svg" alt="" className={`${styles.Icon}`} />)}
          </div>

          <div className={`${styles.HeadConSec}`}>
            <div className={`${styles.prospectNameActionSec}`}>
              <p className={`${styles.ProsUserName} ${styles.CallLink}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/people/tenants/details/" + item.tenant_id); }}>{item?.tenant_name}</p>
              {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                  <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(item); }}>
                    <Edit /> Edit
                  </Dropdown.Item>}
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(item?.id); }}>
                    <Trash2 /> Delete
                  </Dropdown.Item>}
                </Dropdown.Menu>
              </Dropdown>}
            </div>
            <p className={`${styles.ProsUserName}`}>{item?.license}</p>
          </div>
        </div>
        <div className={`${styles.ProspectCardBodySec}`}>
          <ul>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/make.svg" alt="" />
                Make :
              </p>
              <p className={`${styles.Content}`}>{item?.make}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/model.svg" alt="" />
                Model :
              </p>
              <p className={`${styles.Content}`}>{item?.model}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/color.svg" alt="" />
                Color :
              </p>
              <p className={`${styles.Content}`}>{item?.color}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/home.svg" alt="" />
                Property :
              </p>
              <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property_name}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/rooms.svg" alt="" />
                Unit :
              </p>
              <p className={`${styles.Content}`}>{item?.apt_no}</p>
            </li>
          </ul>
        </div>
        <div className={`${styles.TemplateCardFoot}`}>
          {showBadge && (<span className={styles.NewBadge}>New</span>)}
          {/* {parseInt(item?.is_guest) === 1 && (
            <span className={`${styles.PublishBadge}`}>Guest</span>
          )} *//*}
  </div >
      </div >
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: "none" }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
        </div>
      </Popover>

      <Dialog open={openPop} onClose={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
          <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }}><X /></button>
        </div>
      </Dialog>
    </div >*/}


    <div className={`${styles.ProspectCard}`}>
      <div className={`${styles.ProspectCardUnder}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setParkingPanelOpen(true); }}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          <div className={`${styles.LeaseIMGSec}`}>
            {item?.image_path ? (<span onMouseEnter={(e) => { setCarImage(item?.image_path); e.preventDefault(); e.stopPropagation(); handlePopoverOpen(e); }} onMouseLeave={handlePopoverClose} style={{ width: "100%", height: "100%" }}>
              <img src={item?.image_path} className={`${styles.CarUploadImage}`} alt="" />
            </span>) : (<img src="/static/img/car.svg" alt="" />)}
          </div>

          <div className={`${styles.HeadConSec}`}>
            <div className={`${styles.prospectNameActionSec}`}>
              {/* Guest name: plain text. Tenant name: clickable link */}
              {isGuest ? (
                <p className={`${styles.ProsUserName} ${styles.Guest}`}>{item?.name}</p>
              ) : (
                <p className={`${styles.ProsUserName} ${styles.CallLink}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); goToTenantetails(item); }}>{item?.name}</p>
              )}

              {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                  <MoreVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(item); }}>
                    <Edit /> Edit
                  </Dropdown.Item>}
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(item?.id); }}>
                    <Trash2 /> Delete
                  </Dropdown.Item>}
                </Dropdown.Menu>
              </Dropdown>}
            </div>
            <div className={`${styles.prospectNameActionSec}`} style={{ marginBottom: '6px' }}>
              <p className={`${styles.ProsUserName}`}>{item?.license}</p>

              {item?.isNew && <span className={`${styles.PublishBadge}`} style={{ marginLeft: 'auto' }}>New</span>}
              {isGuest && <span className={`${styles.PublishBadge} ${styles.Guest}`}>Guest</span>}
              {item?.is_disabled === 1 && <span className={`${styles.PublishBadge} ${styles.Guest}`}>Disabled</span>}
            </div>

          </div>
        </div>

        <div className={`${styles.ProspectCardBodySec}`}>
          <ul>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/make.svg" alt="" />Make :</p>
              <p className={`${styles.Content}`}>{item?.make}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/model.svg" alt="" />Model :</p>
              <p className={`${styles.Content}`}>{item?.model}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/color.svg" alt="" />Color :</p>
              <p className={`${styles.Content}`}>{item?.color}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/home.svg" alt="" />Property :</p>
              <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/rooms.svg" alt="" />Unit :</p>
              <p className={`${styles.Content}`}>{item?.unit}</p>
            </li>
          </ul>
        </div>
        <div className={`${styles.TemplateCardFoot}`}>
          {isGuest && pass && (<>
            <div className={`${styles.CardPassBadge}`} style={{ backgroundColor: pass.passBackgroundColor, color: pass.passColor }}>
              {pass.passLabel}
            </div>
            <span style={{ color: '#9CA3AF', fontSize: '11px', marginLeft: 'auto', padding: '4px 0' }}>{pass.passSubLabel}</span>
          </>)}
          {!isGuest && <div className={`${styles.CardPassBadge} ${styles.CardPassBadgeGreen}`}>Active</div>}
        </div >

        {/* Parking pass footer — guests only */}
        {/* {isGuest && pass && (
          <div className={`${styles.CardParkingFooter}`}>
            <div
              className={`${styles.CardPassBadge}`}
              style={{ backgroundColor: pass.passBackgroundColor, color: pass.passColor }}
            >
              ● {pass.passLabel}
            </div>
            <button
              className={`${styles.CardParkingBtn}`}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setParkingPanelOpen(true); }}
            >
              Parking details
            </button>
          </div>
        )} */}
      </div>

      {/* ── Parking details side panel (guest only) ── */}
      {isGuest && parkingPanelOpen && pass && (
        <div className={`${styles.ParkingPanelBackdrop}`} onClick={() => setParkingPanelOpen(false)}>
          <div className={`${styles.ParkingPanel}`} onClick={(e) => e.stopPropagation()}>

            {/* Panel header */}
            <div className={`${styles.ParkingPanelHeader}`}>
              <div>
                <div className={`${styles.ParkingPanelTitle}`}>Parking Pass</div>
                <div className={`${styles.ParkingPanelSub}`}>{item?.name} · {item?.license}</div>
              </div>
              <button className={`${styles.ParkingPanelClose}`} onClick={() => setParkingPanelOpen(false)}>
                <X size={16} />
              </button>
            </div>

            {/* Panel body */}
            <div className={`${styles.ParkingPanelBody}`}>

              {/* Guest info */}
              <div className={`${styles.PPSection}`}>
                <div className={`${styles.PPSectionLabel}`}>Guest</div>
                <div className={`${styles.PPInfoCard}`}>
                  <div className={`${styles.PPGuestRow}`}>
                    <div className={`${styles.PPGuestAvatar}`}>
                      {((item?.guest_fname?.[0] || '') + (item?.guest_lname?.[0] || '')).toUpperCase() || 'G'}
                    </div>
                    <div>
                      <div className={`${styles.PPGuestName}`}>{item?.name}</div>
                      <div className={`${styles.PPGuestPhone}`}>{item?.guest_phone || '—'}</div>
                    </div>
                  </div>
                  <div className={`${styles.PPInfoGrid}`}>
                    <div className={`${styles.PPInfoCell}`}>
                      <div className={`${styles.PPInfoLabel}`}>License plate</div>
                      <span className={`${styles.PPLicenseBadge}`}>{item?.license}</span>
                    </div>
                    <div className={`${styles.PPInfoCell}`}>
                      <div className={`${styles.PPInfoLabel}`}>Vehicle</div>
                      <div className={`${styles.PPInfoVal}`}>{item?.make} {item?.model} · {item?.color}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pass details */}
              <div className={`${styles.PPSection}`}>
                <div className={`${styles.PPSectionLabel}`}>Pass details</div>
                <div className={`${styles.PPInfoCard}`}>
                  <div className={`${styles.PPPassTopRow}`}>
                    <div>
                      <div className={`${styles.PPPassType}`}>{pass.passName}</div>
                      <div className={`${styles.PPPassAmount}`}>{pass.passAmount}</div>
                      <div className={`${styles.PPInfoLabel}`}>Total charged</div>
                    </div>
                    <span
                      className={`${styles.PPStatusBadge}`}
                      style={{ backgroundColor: pass.passBackgroundColor, color: pass.passColor, display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                    >
                      {pass.passStatusIcon} {pass.passStatusText}
                    </span>
                  </div>

                  <div className={`${styles.PPInfoGrid}`}>
                    {pass.passValidFrom && (
                      <div className={`${styles.PPInfoCell}`}>
                        <div className={`${styles.PPInfoLabel}`}>Valid from</div>
                        <div className={`${styles.PPInfoVal}`}>{pass.passValidFrom}</div>
                      </div>
                    )}
                    {pass.passWasValid && (
                      <div className={`${styles.PPInfoCell}`}>
                        <div className={`${styles.PPInfoLabel}`}>Was valid</div>
                        <div className={`${styles.PPInfoVal}`}>{pass.passWasValid}</div>
                      </div>
                    )}
                    {pass.passExpires && (
                      <div className={`${styles.PPInfoCell}`}>
                        <div className={`${styles.PPInfoLabel}`}>Expires</div>
                        <div className={`${styles.PPInfoVal}`}>{pass.passExpires}</div>
                      </div>
                    )}
                    {pass.passRemaining && (
                      <div className={`${styles.PPInfoCell}`}>
                        <div className={`${styles.PPInfoLabel}`}>Remaining</div>
                        <div className={`${styles.PPInfoVal}`} style={{ color: '#e23725' }}>{pass.passRemaining}</div>
                      </div>
                    )}
                  </div>

                  {/* Alert strip */}
                  {pass.alertType === "warning" && (
                    <div className={`${styles.PPAlert} ${styles.PPAlertYellow}`}>
                      <AlertTriangle size={14} style={{ flexShrink: 0 }} />
                      {pass.alertText}
                    </div>
                  )}
                  {pass.alertType === "error" && (
                    <div className={`${styles.PPAlert} ${styles.PPAlertRed}`}>
                      <AlertCircle size={14} style={{ flexShrink: 0 }} />
                      <span>{pass.alertText}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Panel footer */}
            <div className={`${styles.ParkingPanelFooter}`}>
              <button className={`${styles.PPBtnGhost}`} onClick={() => setParkingPanelOpen(false)}>
                Close
              </button>
              <button className={`${styles.PPBtnSend}`}>
                <Send size={13} /> Send renewal
              </button>
              <button className={`${styles.PPBtnRevoke}`}>
                {passStatus === 'awaiting' ? 'Cancel pass' : 'Revoke access'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: "none" }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <div className={`${styles.PopupImgSec}`}>
        <img src={carImage} alt="" />
      </div>
    </Popover>

    <Dialog open={openPop} onClose={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <div className={`${styles.PopupImgSec}`}>
        <img src={carImage} alt="" />
        <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }}><X /></button>
      </div>
    </Dialog>
  </>);
};

export default VehicleCard;